import Tools from "@/shared/services/tools";
import gCard from "@/components/g-card/g-card.vue";
import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import ReclamacaoTecnicaController from "@/shared/controllers/reclamacaoTecnica/reclamacaoTecnicaController";

export default {
  name: 'ReclamacaoTecnicaComercialPDF',
  components: { 
    "g-card": gCard,
    "g-button": gButton,
    "g-form": gForm,
  }, 

  props: { 
    reclamacaoTecnicaSelecionada: {
      type: String,
      default: ''
    },
  },

  mounted () { 
    if(this.reclamacaoTecnicaSelecionada){
      this.ReclamacaoTecnicaId = this.reclamacaoTecnicaSelecionada
    } else {
      this.ReclamacaoTecnicaId = this.$route.params.id
    }
    this.GetDetalhesReclamacao()
  },

  updated () { 
    if(this.reclamacaoTecnicaSelecionada){
      this.ReclamacaoTecnicaId = this.reclamacaoTecnicaSelecionada
    } else {
      this.ReclamacaoTecnicaId = this.$route.params.id
    }
    this.GetDetalhesReclamacao()
  },

  data () {
    return { 
      DetalhesReclamacao: [],
      executarvisualizacao: 0,
      renderiza: false,
      Id:'',
      ReclamacaoTecnicaId: null,
      AcompanhaAmostra: false,
      MascaraCnpj: {}
    }
  },

  methods: {
    GetDetalhesReclamacao() {
      let Id = this.ReclamacaoTecnicaId
      this.$isLoading(true)
      ReclamacaoTecnicaController.GetDetalhesReclamacao(Id).requisicao
      .then(response => {
        this.DetalhesReclamacao = response.data.data
        this.AcompanhaAmostra = response.data.data.acompanhaAmostra
        this.MascaraCnpj = Tools.formatarCnpj(response.data.data.cnpj)
        this.executaTermino();

      })
      .finally(this.$isLoading(false))
    },
    executaTermino(){
      this.$emit('termino')
    },
  },

  computed: { }, 

};